import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

const DraggableWrapper = ({
  children,
  id,
  index,
}) => (
  <Draggable key={id} draggableId={id} index={index}>
    {(provided, snapshot) => (
      <div ref={provided.innerRef} {...provided.draggableProps}>
        {children(provided, snapshot)}
      </div>
    )}
  </Draggable>
);

export { DraggableWrapper };
